import { h } from 'preact'
import { route } from 'preact-router'
import FirebaseComponent from './FirebaseComponent'
import './Landing.css'

class Landing extends FirebaseComponent {
  backgroundImage() {
    const random = Math.floor(Math.random() * 4)
    return `https://s3.amazonaws.com/oil-and-gas-organiser-images/images/backgrounds/${random}.jpg`
  }

  render() {
    return (
      <div>
        <img className="background" alt="background" src={this.backgroundImage()} />
        <div className="landing-actions">
          <h1 className="landing-message">Your personal online<br/>organiser</h1>
          <button
            type="button"
            className="btn btn-primary btn-lg landing-button"
            onClick={() => route('/signin', true)} >
            LOGIN NOW
          </button>
          <br/>
          <br/>
          <span>
            <a href="https://itunes.apple.com/gb/app/oago/id1320515823?mt=8"><img style={{ width: 130 }} src="/app-store.svg" alt="app-store-icon" /></a>
            <a href="https://play.google.com/store/apps/details?id=co.uk.oago.OAGO&hl=en"><img style={{ width: 160 }} src="/google-play-badge.svg" alt="google-play-icon" /></a>
          </span>
        </div>
      </div>
    )
  }
}

export default Landing



// WEBPACK FOOTER //
// ./src/Landing.js